// Copyright (c) 2016 Deere & Company

import * as fetchService from '../../../shared/services/fetch';
import {handleError} from '../../../shared/services/error-handlers';

const basePath = '/api';

export async function postClaim(payload, claimType) {

    const endPoint = `${basePath}/${claimType}`;

    const options = {
        body: JSON.stringify(payload),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getClaim(claimNumber, claimType) {

    const endPoint = `${basePath}/${claimType}/${claimNumber}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getApplyTravel(args) {

    const endPoint = `${basePath}/apply-travel?${args}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getPartDetails(partNumber) {

    const endPoint = `${basePath}/parts?partNumber=${encodeURIComponent(partNumber)}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getInstalledBy(claimTypeKey) {

    const endPoint = `${basePath}/constants?id=INSTALLED_BY&filter1Key=CLAIM_TYPE&filter1Value=${claimTypeKey}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getOwnershipStatus() {

    const endPoint = `${basePath}/constants?id=OWNERSHIP_STATUS`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getPartUseUnits() {

    const endPoint = `${basePath}/constants?id=PARTUSE_UNIT`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getLaborLocations(accountId, pin = '', suppressErrors = false) {

    const endPoint = `${basePath}/labor-sub-types/${accountId}?pin=${pin}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return suppressErrors ? response.json : handleError(response);

    }

}

export async function getLaborTypes(dealerId) {

    const endPoint = `${basePath}/labor-types/${dealerId}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getFailureModes(claimTypeKey) {

    const endPoint = `${basePath}/constants?id=FAILURE_MODE&filter1Key=CLAIM_TYPE&filter1Value=${claimTypeKey}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getApplication(claimTypeKey) {

    const endPoint = `${basePath}/constants?id=APPLICATION&filter1Key=CLAIM_TYPE&filter1Value=${claimTypeKey}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getDownTime() {

    const endPoint = `${basePath}/constants?id=DOWN_TIME`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getOtherCreditTypes(claimTypeKey, spaType) {

    const endPoint = spaType ?
        `${basePath}/constants?id=OTHERCREDIT_TYPE&filter2Key=CLAIM_TYPE&filter2Value=${claimTypeKey}&filter3Key=SPA_TYPE&filter3Value=${spaType}` :
        `${basePath}/constants?id=OTHERCREDIT_TYPE&filter2Key=CLAIM_TYPE&filter2Value=${claimTypeKey}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getDealerInvoices(payload) {

    const endPoint = payload.export === 'EXCEL' ?
        `${basePath}/invoices/collection?export=EXCEL` :
        `${basePath}/invoices/collection`;

    const fetchOptions = {
        body: JSON.stringify(payload),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, fetchOptions);

        return payload.export === 'EXCEL' ?
            response :
            response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function putDealerInvoices(invoice) {

    const endPoint = `${basePath}/invoices/${invoice.invoiceId}`;

    const fetchOptions = {
        body: JSON.stringify(invoice),
        method: 'PUT'
    };

    try {

        return await fetchService.fetch(endPoint, fetchOptions);

    } catch (error) {

        return handleError(error);

    }

}

export async function getClaimSearchResults(query, searchBy) {

    const endPoint = `${basePath}/claims/search?by=${searchBy}&q=${encodeURIComponent(query)}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getAllClaimResults(payload) {

    const endPoint = payload.export === 'EXCEL' ?
        `${basePath}/claims/collection?export=EXCEL` :
        `${basePath}/claims/collection`;

    const fetchOptions = {
        body: JSON.stringify(payload),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, fetchOptions);

        return payload.export === 'EXCEL' ?
            response :
            response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getClaimsInProgress(status) {

    const endPoint = `${basePath}/claims?claimStatus=${status}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getPipProducts(query) {

    const endPoint = `${basePath}/pip-products/search?by=PIN&q=${encodeURIComponent(query)}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getPipDetails(pipId) {

    const endPoint = `${basePath}/pips/${pipId}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getClaimTypes() {

    const endPoint = `${basePath}/constants?id=CLAIM_TYPE`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function validateAttachmentItemNumber(itemNumber) {

    const endPoint = `${basePath}/items/${itemNumber}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getGoodsInstallationVatOptions() {

    const endPoint = `${basePath}/constants?id=PIP_METRIC`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getLugheightUOM() {

    const endPoint = `${basePath}/constants?id=LUGHEIGHT_UOM`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getSpaTypes(dealerId) {

    const endPoint = `${basePath}/special-allowance-types/${dealerId}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getMccQuestions() {

    const endPoint = `${basePath}/constants?id=MCC_QUESTIONS`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getMethodOfContact() {

    const endPoint = `${basePath}/constants?id=METHOD_OF_CONTACT`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getQuestionsRequired() {

    const endPoint = `${basePath}/constants?id=QUESTIONS_REQUIRED`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getRelationship() {

    const endPoint = `${basePath}/constants?id=RELATIONSHIP`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getRetailerNames() {

    const endPoint = `${basePath}/constants?id=RETAILER_NAME`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getJdpReason() {

    const endPoint = `${basePath}/constants?id=JDP_REASON`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getJdpResolution() {

    const endPoint = `${basePath}/constants?id=JDP_RESOLUTION`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getOpenMaintenancePlans(claim) {

    const endPoint = `${basePath}/open-maintenance-plans?pin=${claim.pin}&dealerId=${claim.responsibleAccount.account}&serviceDate=${claim.serviceDate}&useAmount=${claim.useAmount.amount}&useAmountUnit=${claim.useAmount.unit.key}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getOpenServiceIntervals(planName, claim) {

    const endPoint = `${basePath}/open-maintenance-plans/${encodeURIComponent(planName).replace(/%2F/g, '+')}/open-service-intervals?pin=${claim.pin}&dealerId=${claim.responsibleAccount.account}&serviceDate=${claim.serviceDate}&useAmount=${claim.useAmount.amount}&useAmountUnit=${claim.useAmount.unit.key}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getLaborRateDealers() {

    const endPoint = `${basePath}/labor-rates/collection`;

    const body = {
        accounts: [],
        getForTcsm: false
    };

    const fetchOptions = {
        body: JSON.stringify(body),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, fetchOptions);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getSelectedDealersLaborRate(payload) {

    const endPoint = `${basePath}/labor-rates/collection`;

    const fetchOptions = {
        body: JSON.stringify(payload),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, fetchOptions);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getLaborRatesForRequestID(requestId, getForTcsm) {

    const canGetForTcsm = getForTcsm || false;

    const endPoint = `${basePath}/labor-rates?getForTcsm=${canGetForTcsm}&requestId=${requestId}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getLaborRatesForAccount(account, getForTcsm) {

    const canGetForTcsm = getForTcsm || false;

    const endPoint = `${basePath}/labor-rates/${account}?getForTcsm=${canGetForTcsm}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getAllRequestAsPerStatus(requestStatus, getForTcsm, requestId) {

    const canGetForTcsm = getForTcsm || false;

    const endPoint = `${basePath}/labor-rates?getForTcsm=${canGetForTcsm}&requestStatus=${requestStatus}`;

    const endPointWithOptionalParam = requestId ? `${endPoint}&requestId=${requestId}` : endPoint;

    try {

        const response = await fetchService.fetch(endPointWithOptionalParam);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function postLaborRates(laborRate) {

    const endPoint = `${basePath}/labor-rates`;

    const fetchOptions = {
        body: JSON.stringify(laborRate),
        method: 'POST'
    };

    try {

        return await fetchService.fetch(endPoint, fetchOptions);

    } catch (response) {

        return handleError(response);

    }

}

export async function postMassLaborRates(massLaborRate) {

    const endPoint = `${basePath}/labor-rates`;

    const fetchOptions = {
        body: JSON.stringify(massLaborRate),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, fetchOptions);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function postPin(pin) {

    const endPoint = `${basePath}/pins`;

    const fetchOptions = {
        body: JSON.stringify(pin),
        method: 'POST'
    };

    try {

        return await fetchService.fetch(endPoint, fetchOptions);

    } catch (error) {

        return handleError(error);

    }

}

export async function getLaborRateCount() {

    const endPoint = `${basePath}/labor-rates-request-summary`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}



// WEBPACK FOOTER //
// ./src/claim/shared/repositories/index.js